import { Link } from 'react-router-dom';
import { Reveal } from '@/components/Reveal';

// Cinematic horizontally-scrolling film-strip showcase — an alternative to
// the static grid for browsing featured work with a drag/scroll gesture.
export const FilmStripGallery = ({ items = [], kicker = 'Recent Work', title = 'A GLIMPSE INTO THE LENS' }) => {
  if (!items.length) return null;
  return (
    <section className="bg-[#0A0A0A] border-t border-[hsl(var(--lxra-border))]" data-testid="filmstrip-gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-16 lg:py-20">
        <Reveal>
          <p className="text-xs tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))] mb-2">{kicker}</p>
          <h2 className="font-display text-3xl sm:text-4xl tracking-[0.04em] text-[hsl(var(--lxra-fg))] mb-2">{title}</h2>
          <p className="text-xs text-[hsl(var(--lxra-muted))] mb-8">Drag or scroll to explore &rarr;</p>
        </Reveal>
      </div>
      <Reveal>
        <div
          className="flex gap-4 sm:gap-6 overflow-x-auto snap-x snap-mandatory pb-4 px-4 sm:px-6 lg:px-10 lxra-scrollbar-hide"
          data-testid="filmstrip-scroll-track"
        >
          {items.map((item, i) => (
            <Link
              key={item.slug || i}
              to={item.to || '#'}
              className="group relative flex-shrink-0 snap-start w-[240px] sm:w-[300px] lg:w-[360px] aspect-[4/5] overflow-hidden rounded-xl border border-[hsl(var(--lxra-border))]"
              data-testid={`filmstrip-item-${i}`}
            >
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 flex items-center gap-3">
                <span className="text-[10px] tracking-[0.18em] text-[hsl(var(--lxra-gold))]">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-sm uppercase tracking-[0.12em] text-white font-medium">{item.title}</span>
              </div>
            </Link>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
